import axios from "@/api/axios";

type errorHandling = (error: any) => any;

export abstract class DefaultService {
  entityUrl = "";

  getUrlFiltersQuery(filters: any): string {
    let urlFilters = "&";
    const filterArr = filters ? Object.entries(filters) : [];
    filterArr.forEach((el, index) => {
      if (el[1] && el[1] != "") {
        urlFilters += `filter[${el[0]}]=${el[1]}`;
        urlFilters += index == filterArr.length - 1 ? "" : "&";
      }
    });

    return urlFilters;
  }

  getUrlIncludesQuery(includes: Array<string>): string {
    let urlIncludes = "&";
    if (includes.length > 0) {
      urlIncludes += "include=";
      includes.forEach(
        (el, index) => (urlIncludes += `${el}` + (index < includes.length - 1 ? "," : ""))
      );
    }

    return urlIncludes;
  }

  index(
    page: any,
    pageSize: any,
    filters: any = null,
    includes: Array<string> = [],
    sort = "",
    errorHandling: errorHandling = this.errorDefaultMessage
  ): Promise<any> {
    const urlFilters = this.getUrlFiltersQuery(filters);
    const urlIncludes = this.getUrlIncludesQuery(includes);
    const urlSort = sort != "" ? `&sort=${sort}` : "";

    return new Promise((resolve, reject) => {
      axios
        .get(
          `${this.entityUrl}?page[number]=${page}&page[size]=${pageSize}${urlFilters}${urlIncludes}${urlSort}`
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(errorHandling(error));
        });
    });
  }

  store(dataObj: any, errorHandling: errorHandling = this.errorDefaultMessage): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.entityUrl}`, dataObj)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(errorHandling(error));
        });
    });
  }

  update(
    id: number,
    dataObj: any,
    errorHandling: errorHandling = this.errorDefaultMessage
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.entityUrl}/${id}`, dataObj)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(errorHandling(error));
        });
    });
  }

  get(id: number, errorHandling: errorHandling = this.errorDefaultMessage): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(errorHandling(error));
        });
    });
  }

  destroy(id: any, errorHandling: errorHandling = this.errorDefaultMessage): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${this.entityUrl}/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(errorHandling(error));
        });
    });
  }

  errorDefaultMessage(error: any): void {
    console.error("%c Pending error handling => ", "font-weight: bold", error);
  }
}
